/* eslint-disable */
require('./alarm')
require('./apple-ical')
require('./arrow-return')
require('./arrow')
require('./attach')
require('./audio')
require('./best-quality')
require('./btn-arrow-2')
require('./btn-arrow')
require('./burger-menu')
require('./burger')
require('./calendar')
require('./chromecast')
require('./close-menu')
require('./close')
require('./coal')
require('./download')
require('./email')
require('./external')
require('./facebook')
require('./fax')
require('./file')
require('./globe')
require('./google-calendar')
require('./high-skill')
require('./image')
require('./instagram')
require('./interactive')
require('./internal')
require('./link')
require('./logistic')
require('./minus')
require('./modal-arrow')
require('./ms-Outlook')
require('./odnoklassniki')
require('./phone')
require('./photo-library')
require('./placeholder')
require('./play')
require('./plus')
require('./presentation')
require('./press-release')
require('./print')
require('./raw-material')
require('./report')
require('./reset')
require('./rss')
require('./search')
require('./share')
require('./steel')
require('./telegram')
require('./tooltip')
require('./transcript')
require('./twitter')
require('./user-circle')
require('./user')
require('./vanadium')
require('./video-library')
require('./video')
require('./vk')
require('./youtube')
require('./zoom-in-map')
require('./zoom-out-map')
require('./zoom')
